import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';

export default class pdfGeneratingModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = false;

  oninit(vnode) {
    super.oninit(vnode);
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return [];
  }

  content() {
    return [
      <div className="Modal-body u2diSubmitModalBody" style="text-align: center;">
        <div className="Form-group" style="font-size: 18px;padding-bottom: 10px;">
          文档生成中，请稍后
        </div>
      </div>
    ];
  }
}
